<template>
  <v-footer absolute class="font-weight-medium footer-frame offside-bottom">
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="4" class="pl-0 pl-md-3">
          <div class="text-caption d-flex flex-column justify-content-center pb-2">
            <a :href="homepage">
              <v-img   max-width="80" :src="siteConfig.logo" alt="" />
            </a>
            <h3>{{ siteConfig.meta_title }}</h3>
            <span>{{ siteConfig.meta_description }}</span>
            <span>
              {{
              siteConfig.config_address ? siteConfig.config_address + "," : ""
            }}
              {{
                siteConfig.config_city_name
                  ? siteConfig.config_city_name + ","
                  : ""
              }}
              {{
                siteConfig.config_province_name
                  ? siteConfig.config_province_name + " - "
                  : ""
              }}
              {{ siteConfig.config_zipcode ? siteConfig.config_zipcode : "" }}
            </span>
            <span>Whatsapp
              <a target="_blank" :href="`https://wa.me/${siteConfig.config_phone}`">{{ siteConfig.config_phone
                }}</a></span>
          </div>
          <div class="text-caption">
            <ul class="d-flex list-unstyled pl-0" dense dark>
              <li link class="d-flex align-center" :href="row.sosmed_account_link"
                v-for="(row, index) in sosmedAccountList" :key="index">
                <div class="pr-2">
                  <a :href="row.sosmed_account_link" target="_blank">
                    <v-img width="25" :src="row.sosmed_account_image" />
                  </a>
                </div>
                <!-- <div
                    class="pl-2"
                    style="cursor: pointer"
                    @click="openLink(row.sosmed_account_link)"
                  >
                    {{ row.sosmed_account_name }}
                  </div> -->
              </li>
            </ul>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="2" class="pl-0 pl-md-3">
          <div class="text-uppercase text-caption font-weight-bold pb-2">
            Informasi
          </div>
          <div class="text-caption" v-if="content['Lainnya']">
            <router-link :to="'/page/' + data.content_slug" v-for="data in content['Lainnya']" :key="data.content_id"
              class="text-deco">
              <div class="pt-1 text-capitalize">{{ data.content_title }}</div>
            </router-link>
          </div>
          <div class="text-caption" v-if="content['Layanan Pelanggan']">
            <router-link :to="'/page/' + data.content_slug" v-for="data in content['Layanan Pelanggan']"
              :key="data.content_id" class="text-deco">
              <div class="pt-1 text-capitalize">{{ data.content_title }}</div>
            </router-link>
          </div>
          <div class="text-caption" v-else></div>
        </v-col>
        <!-- <v-col cols="6" sm="3" md="2" class="pr-0 pr-md-3">
          <div class="text-uppercase text-caption font-weight-bold pb-2">Perusahaan</div>
          <div class="text-caption" v-if="content['Lainnya']">
            <router-link :to="'/page/' + data.content_slug" v-for="data in content['Lainnya']" :key="data.content_id"
              class="text-deco black--text">
              <div class="pt-1 text-capitalize">{{ data.content_title }}</div>
            </router-link>
          </div>
          <div class="text-caption" v-else></div>
        </v-col> -->
        <v-col v-if="supportBankList.length" cols="6" sm="6" md="3" class="pl-0 pl-md-3">
          <div class="text-uppercase text-caption font-weight-bold pb-2">
            Mendukung Pembayaran
          </div>
          <div class="mt-3">
            <v-col class="py-0">
              <v-row>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1" v-for="(row, idx) in supportBankList" :key="idx">
                  <v-img contain class="img-fluid mx-auto"  width="66"  eager :src="row.support_bank_image" :alt="row.support_bank_name"></v-img>
                </v-col>

              </v-row>
            </v-col>
          </div>
        </v-col>
        <v-col v-if="courier.length" cols="6" sm="6" md="3" class="pr-0 pr-md-3">
          <div class="text-uppercase text-caption font-weight-bold pb-2">
            Pengiriman
          </div>
          <div class="mt-3">
            <v-col class="py-0">
              <v-row  >
                <v-col v-for="(item, idx) in courier" :key="idx" cols="4" class="pl-0 pl-md-3  d-flex flex-column align-center justify-content-center" >
                  <v-img contain class="img-fluid mx-auto my-auto"  width="66"  :title="item.courier_name" eager :src="`/assets/courier/${item.courier_code}.svg`"></v-img>
                </v-col>
              </v-row>
              <!-- <v-row v-else>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/jne.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/j&t.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/sicepat.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/tiki.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/ninja.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/pos.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/jet.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/lion.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/wahana.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/pahala.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/dse.svg"></v-img>
                </v-col>
                <v-col cols="4" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/pandu.svg"></v-img>
                </v-col>
              </v-row> -->
            </v-col>
          </div>
        </v-col>

      </v-row>
      <v-row>
        <v-col class="pt-2 pb-0 px-0 pt-md-0 px-md-3">
          <v-divider></v-divider>
          <div class="pt-4 pb-1 text-caption text-center">
            &copy; {{ new Date().getFullYear() }} {{ siteConfig.meta_title }}.
            Hak Cipta Dilindungi
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    homepage() {
      return process.env.VUE_APP_HOMEPAGE || ''
    },
    ...mapState("options", ["courier", "supportBankList"]),
    ...mapState("kiriminaja", ["sosmedAccountList", "siteConfig"]),
    ...mapState("content", ["content"]),
    socialIcons() {
      return [
        {
          name: "Facebook",
          icon: "mdi-facebook",
          link: "https://facebook.com",
        },
        { name: "Twitter", icon: "mdi-twitter", link: "https://twitter.com" },
        {
          name: "Instagram",
          icon: "mdi-instagram",
          link: "https://instagram.com",
        },
      ];
    },
  },
  methods: {
    ...mapActions("kiriminaja", ["getSosmedAccountList"]),
    ...mapActions("options", ["getCourier", "getSupportBank"]),
    ...mapActions("content", ["getContent"]),
  },
  created() {
    this.getSupportBank()
    this.getContent();
    this.getSosmedAccountList();
    this.getCourier();
  },
};
</script>
